import React from "react";
import "lazysizes";

export const wrapRootElement = ({ element }) => (
  <>
    {element}
  </>
);

export const shouldUpdateScroll = ({ routerProps }) => {
  const hash = routerProps?.location?.hash;
  if (hash) {
    const el = document.querySelector(hash);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
      return false;
    }
  }
  window.scrollTo(0, 0);
  return false;
};
